<script lang="ts">
	import type { PageData } from '../$types';
	import Footer from '$lib/components/footer/Footer.svelte';
	import ExpenseNoteEdition from '$lib/components/route-details/expense-note/ExpenseNoteEdition.svelte';

	export let data: PageData;
	$: ({ partnersLinks } = data);
</script>

<ExpenseNoteEdition />
<Footer {partnersLinks} />
